/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require("axios");

function doFade($el) {
    const faderClass = "d-none";
    if ($el.classList.contains(faderClass)) {
        $el.classList.remove(faderClass);
    } else {
        $el.classList.add(faderClass);
    }
}

document.addEventListener(
    "DOMContentLoaded",
    function() {
        setTimeout(() => {
            // try to assign value then exec or else do nothing
            const $2FaRetrySendSMSButton = document.querySelector(
                "#retrybutton"
            );
            if ($2FaRetrySendSMSButton) doFade($2FaRetrySendSMSButton);
        }, 5000);
    },
    false
);

window.axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";
window.axios.defaults.headers.common["Accept"] = "application/json";
window.axios.interceptors.response.use(
    function(response) {
        // Any status code that lie within the range of 2xx cause this function to trigger
        // Do something with response data
        return response;
    },
    function(error) {
        if (error.response) {
            const code = parseInt(error.response.status)
            if (code == 401) {
                window.location.reload();
            } else {
                alert('Une erreur est survenue. Veuillez contacter votre administrateur système')
            }
        } else {
            alert('Erreur reseaux')
        }
        return Promise.reject(error);
    }
);
